import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11 2.58569L5.98959 7.5961C2.67014 10.9156 2.67014 16.2975 5.98959 19.6169C7.39452 21.0218 9.1689 21.8322 11 22.0478V2.58569Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13 22.0478C13.8092 21.9525 14.6073 21.7411 15.3673 21.4135C15.6098 21.3117 15.8485 21.1951 16.0852 21.063C16.7711 20.6868 17.4161 20.2089 17.998 19.6293C18.8886 18.7953 19.5191 17.7894 19.9155 16.71C21.1094 13.6604 20.4744 10.0601 18.0104 7.5961L13 2.58569V22.0478Z"}}]};

const ColorInvertFilled = Vue.extend<IconProps>({
  name: 'ColorInvertFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'color-invert-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default ColorInvertFilled;
